var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "gg-card",
        [
          _c(
            "gg-card-header",
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    {
                      attrs: {
                        md: "6"
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.title) + " ")]
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass:
                        "d-flex flex-sm-row flex-column justify-end align-start gap-sm align-md-center",
                      attrs: {
                        md: "6"
                      }
                    },
                    [_vm._t("header-actions")],
                    2
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm.newAccount
            ? _c(
                "gg-card-title",
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          attrs: {
                            cols: "12",
                            sm: "8",
                            md: "8"
                          }
                        },
                        [_c("add-new-account")],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "v-card-text",
            [
              _c("v-data-table", {
                attrs: {
                  headers: _vm.tableHeaders,
                  items: _vm.filteredItems,
                  "item-key": "virtualId",
                  search: _vm.search,
                  "footer-props": {
                    itemsPerPageOptions: _vm.itemsPerPageOptions
                  },
                  "sort-by": "domain",
                  "sort-asc": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.domain",
                    fn: function fn(_ref) {
                      var item = _ref.item
                      return [
                        _c(
                          "div",
                          [
                            _c("router-link", {
                              attrs: {
                                to: _vm.manageServiceLink(item),
                                custom: ""
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function fn(_ref2) {
                                      var navigate = _ref2.navigate
                                      return [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "ggs-item-title primary--text",
                                            attrs: {
                                              role: "link",
                                              "aria-label": "Manage"
                                            },
                                            on: {
                                              click: navigate,
                                              keypress: function keypress(
                                                $event
                                              ) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                ) {
                                                  return null
                                                }
                                                return navigate($event)
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(item.domain) + " "
                                            )
                                          ]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            }),
                            !_vm.hideIcons
                              ? [
                                  item.sharedaccount || item.sharedaccess
                                    ? _c(
                                        "router-link",
                                        {
                                          staticClass: "pl-1",
                                          attrs: {
                                            to: {
                                              name: "profile_access"
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                small: ""
                                              }
                                            },
                                            [_vm._v("mdi-account-multiple")]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ]
                              : _vm._e(),
                            _c(
                              "v-tooltip",
                              {
                                attrs: {
                                  top: ""
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function fn(_ref3) {
                                        var on = _ref3.on,
                                          attrs = _ref3.attrs
                                        return [
                                          item.cancellation_pending
                                            ? _c(
                                                "router-link",
                                                {
                                                  staticClass: "pl-1",
                                                  attrs: {
                                                    to: "/cancellations/".concat(
                                                      item.cancellation_id
                                                    ),
                                                    "aria-label": "View Request"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    _vm._g(
                                                      _vm._b(
                                                        {
                                                          attrs: {
                                                            color: "orange",
                                                            small: ""
                                                          }
                                                        },
                                                        "v-icon",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    ),
                                                    [
                                                      _vm._v(
                                                        "mdi-alert-outline"
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              },
                              [
                                _c("div", [
                                  _vm._v(
                                    "This service has a pending cancellation."
                                  )
                                ]),
                                _c("div", [
                                  _vm._v("Click to view/update your request.")
                                ])
                              ]
                            ),
                            _c("br"),
                            _c(
                              "v-icon",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: item.flag,
                                    expression: "item.flag"
                                  }
                                ],
                                staticClass: "mr-1 caption"
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.iconFlag(item.flag)) + " "
                                )
                              ]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "caption"
                              },
                              [_vm._v(_vm._s(item.name))]
                            )
                          ],
                          2
                        )
                      ]
                    }
                  },
                  {
                    key: "item.status",
                    fn: function fn(_ref4) {
                      var item = _ref4.item
                      return [
                        _c(
                          "div",
                          [
                            _c(
                              "v-icon",
                              {
                                staticClass: "pb-1",
                                attrs: {
                                  small: "",
                                  color: _vm.statusColor(item.status)
                                }
                              },
                              [_vm._v("mdi-circle")]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "pl-1"
                              },
                              [_vm._v(_vm._s(item.status))]
                            )
                          ],
                          1
                        )
                      ]
                    }
                  },
                  {
                    key: "item.renewaldate",
                    fn: function fn(_ref5) {
                      var item = _ref5.item
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "hidden-xs-only"
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.formatRenewalDate(
                                    _vm.parseRenewalDate(item.renewaldate)
                                  )
                                ) +
                                " "
                            )
                          ]
                        )
                      ]
                    }
                  },
                  {
                    key: "item.actions",
                    fn: function fn(_ref6) {
                      var item = _ref6.item
                      return [
                        _c(
                          "div",
                          [
                            _c(
                              "gg-btn",
                              {
                                staticClass: "mr-1",
                                attrs: {
                                  to: _vm.manageServiceLink(item)
                                }
                              },
                              [_vm._v(" Manage ")]
                            ),
                            item.type === _vm.SERVICE_TYPES.CPANEL
                              ? _c(
                                  "gg-btn",
                                  {
                                    staticClass: "mr-1",
                                    attrs: {
                                      to: "/hosting/shared/".concat(
                                        item.id,
                                        "/email-accounts"
                                      ),
                                      secondary: ""
                                    }
                                  },
                                  [_vm._v(" Email ")]
                                )
                              : _vm._e(),
                            _vm.isSimplified && item.builders.length
                              ? [
                                  _c(
                                    "gg-btn",
                                    {
                                      staticClass: "mr-1",
                                      attrs: {
                                        secondary: ""
                                      },
                                      on: {
                                        click: function click($event) {
                                          return _vm.manageBuilderLink(item)
                                        }
                                      }
                                    },
                                    [
                                      item.builders.length === 1
                                        ? _c(
                                            "span",
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    item.builders.at(0).name
                                                  )
                                                )
                                              ]),
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "mb-1 ml-1",
                                                  attrs: {
                                                    small: ""
                                                  }
                                                },
                                                [_vm._v("mdi-open-in-new")]
                                              )
                                            ],
                                            1
                                          )
                                        : _c("span", [_vm._v("Builders")])
                                    ]
                                  )
                                ]
                              : _vm._e(),
                            _vm.hasServiceWP(item.id)
                              ? _c(
                                  "gg-btn",
                                  {
                                    staticClass: "mr-1",
                                    attrs: {
                                      to: "/hosting/shared/".concat(
                                        item.id,
                                        "/wordpress/install-and-manage"
                                      ),
                                      secondary: ""
                                    }
                                  },
                                  [_vm._v(" WordPress ")]
                                )
                              : _vm._e(),
                            item.type === _vm.SERVICE_TYPES.CPANEL
                              ? _c(
                                  "gg-btn",
                                  {
                                    staticClass: "mr-1 text-none",
                                    attrs: {
                                      text: ""
                                    },
                                    on: {
                                      click: function click($event) {
                                        return _vm.launch_cpanel(item.id)
                                      }
                                    }
                                  },
                                  [_vm._v(" cPanel ")]
                                )
                              : _vm._e(),
                            item.type === _vm.SERVICE_TYPES.RESELLER
                              ? _c(
                                  "gg-btn",
                                  {
                                    staticClass: "mr-1",
                                    attrs: {
                                      text: ""
                                    },
                                    on: {
                                      click: function click($event) {
                                        return _vm.launch_whm(item.id)
                                      }
                                    }
                                  },
                                  [_vm._v(" WHM ")]
                                )
                              : _vm._e()
                          ],
                          2
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }